import Checkbox from 'components/FormFields/checkbox';
import React, { useState } from 'react';
import { createTag } from 'services/api/tags';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddTagModal = props => {
  const [value, setValue] = useState<string>('');
  const [enValue, setEnValue] = useState<string>('');
  const [isPublic, setIsPublic] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    toggleModal,
    onSuccess,
  } = props;
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createTag({ value, enValue, isPublic });
      showSuccess(`Tag added successfully`);
      onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className={styles['main-container-tag-modal']}>
      <div className={styles['modal-container-tag-modal']}>
        <div className={styles['modal-header']}>
          <div>
            {/* <div className={styles['label']}>Add Tag</div> */}
            <div className={styles['modal-title']}>{`Add Tag`}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Value</div>
            <input
              className={'form-control'}
              value={value}
              type="text"
              onChange={e => setValue(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="mt-2">
            <div className={styles['label']}>English Value</div>
            <input
              className={'form-control'}
              value={enValue}
              type="text"
              onChange={e => setEnValue(e.target.value)}
              disabled={loading}
            />
          </div>
          <Checkbox title="Public" isChecked={isPublic} setIsChecked={setIsPublic} />
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddTagModal;